import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiModule } from '@app/ui';
import { BadgeComponent, IconComponent } from '@ui';

@Component({
  selector: 'sbnb-step-trigger',
  standalone: true,
  templateUrl: './step-trigger.component.html',
  styles: `
    @import 'variables';
    .container:hover {
      .arrow {
        color: $grape-darker;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, UiModule, IconComponent, BadgeComponent],
})
export class StepTriggerComponent {
  @Input() headline: string;
  @Input() customHeadline = false; // If true, the custom headline will be rendered instead of the headline string
  @Input() subline: string;
  @Input() emphasize = false;
  @Input() new = false;
  @Input() on = false;
}
